import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Batch } from '../../models/batchDataModel';
import { BatchValidationModel } from '../../models/BatchValidationModel';
import { UpdateBatchModel } from '../../models/UpdateBatchModel';
import { UpdateResult } from '../../models/UpdateResults';
import { BaseApiService } from '../base-api.service';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class BatchService {
  baseUrl = window.location.origin;
  token = '';
  canEdit: boolean = false;
  constructor(
    private http: HttpClient,
    private baseAPIService: BaseApiService,
    public user: UserService,
  ) {
    this.user.token.subscribe(value => {
      this.token = value;
    });
    user.canEdit.subscribe(v => {
      this.canEdit = v;
    });
  }

  GetOpenBatches(): Promise<Batch[]> {
    let url = this.baseUrl + '/api/Batch/GetBatches';
    this.baseAPIService.token = this.token;
    return this.baseAPIService.get<Batch[]>(url);
  }

  InvalidateBatch(batchModel: BatchValidationModel): Promise<UpdateResult> {
    let url = this.baseUrl + '/api/Batch/InValidateBatch';
    if (this.canEdit) {
      this.baseAPIService.headerToken = this.token;
      return this.baseAPIService.postTU<BatchValidationModel, UpdateResult>(
        url,
        batchModel,
      );
    } else {
      let ur: UpdateResult = {
        success: false,
        recordsUpdated: 0,
        message: 'Not authorized to alter cross references.',
      };
      return new Promise<UpdateResult>(res => {
        res(ur);
      });
    }
  }
  ValidateBatch(batchModel: BatchValidationModel): Promise<UpdateResult> {
    let url = this.baseUrl + '/api/Batch/ValidateBatch';
    if (this.canEdit) {
      this.baseAPIService.headerToken = this.token;
      return this.baseAPIService.postTU<BatchValidationModel, UpdateResult>(
        url,
        batchModel,
      );
    } else {
      let ur: UpdateResult = {
        success: false,
        recordsUpdated: 0,
        message: 'Not authorized to alter cross references.',
      };
      return new Promise<UpdateResult>(res => {
        res(ur);
      });
    }
  }

  MarkBatchAsReviewed(batchModel: UpdateBatchModel): Promise<UpdateResult> {
    let url = this.baseUrl + '/api/Batch/MarkBatchReviewed';
    if (this.canEdit) {
      this.baseAPIService.headerToken = this.token;
      return this.baseAPIService.postTU<UpdateBatchModel, UpdateResult>(
        url,
        batchModel,
      );
    } else {
      let ur: UpdateResult = {
        success: false,
        recordsUpdated: 0,
        message: 'Not authorized to alter cross references.',
      };
      return new Promise<UpdateResult>(res => {
        res(ur);
      });
    }
  }

  MarkBatchAsNotNew(batchModel: UpdateBatchModel): Promise<UpdateResult> {
    let url = this.baseUrl + '/api/Batch/UpdateBatches';
    if (this.canEdit) {
      this.baseAPIService.headerToken = this.token;
      return this.baseAPIService.postTU<UpdateBatchModel, UpdateResult>(
        url,
        batchModel,
      );
    } else {
      let ur: UpdateResult = {
        success: false,
        recordsUpdated: 0,
        message: 'Not authorized to alter cross-references.',
      };
      return new Promise<UpdateResult>(res => {
        res(ur);
      });
    }
  }
}
